import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import styles from './styles.less';

const ItemSkeleton: FC = () => (
    <div className={styles.itemSkeleton}>
        <Skeleton width="100%" height="100%" borderRadius={8} baseColor="#D1E4FE" highlightColor="#0070FF" />
    </div>
);

export default ItemSkeleton;
